import { render, staticRenderFns } from "./email-content.vue?vue&type=template&id=621c3bfc&"
import script from "./email-content.vue?vue&type=script&lang=js&"
export * from "./email-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports